<template>
	<div>
		<div class="row">
			<div class="col-md-12">
				<el-card shadow="hover" :body-style="{ padding: '10px 10px' }">
					<div slot="header">
						<h5 class="text-center m-0 px-2">{{ title }}</h5>
					</div>
					<div class="list-item-container px-2">
						<table class="table-outstanding-status-by-area" style="width: 100%;" cellpadding="2">
							<thead>
								<tr class="">
									<td class="py-1 text-muted"><em>Rank</em></td>
									<!--<td class="text-center text-muted"><em>Branch Id</em></td> -->
									<td class="text-left text-muted"><em>Branch Name</em></td>
									<!--<td class="text-center text-muted"><em>Area</em></td>-->
									<td class="text-right text-muted"><em>Sales (IDR)</em></td>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in data" :key="title+'_'+item.BranchID">
									<td class="text-center py-1 ">{{ ++index }}</td>
									<!--<td class="text-center">{{ item.BranchID }}</td>-->
									<td>{{ item.BranchName }}</td>
									<!--<td class="text-center">{{ item.SalesArea }}</td>-->
									<td class="text-right font-weight-bold">{{ formatNum(item.Amount, 0) }}</td>
								</tr>
								
							</tbody>
						</table>
					</div>
					<Loader v-if="loading" />
				</el-card>
			</div>
		</div>
	</div>
</template>

<script>
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Fuel from '@/components/page/Fuel.js'
import Footer from '@/views/Footer.vue'
import PieChart from '@/components/chart/Pie.js'
import { Rainbow, Rainbow3, Penanggalan, AppColors, Config, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'

export default{
	extends: Fuel,
	components:{
		Loader,
		//ListItem,
		//ListCompare,
		//BarCard,
		//PieChart,
		//Footer            
	},
	props: {
        title: {
            type: String,
            default: 'NET SALES',
            //required: false,
        },
        area: {
            type: String,
            default: '',
            //required: false,
        },
        status :{
            type: String,
            default: '',
            //required: false,
        },
		data: {
			type: Array,
			default: () => []
		},
		loading: {
            type: Boolean,
            default: false,
        },
		/*
		data: {
			type: Object,
			default: () => ({})
		},*/
    },
	data() {
		return {
			reportdata: [],
            value: 0,
			/*
			loading: {
				table: false,
				chart: false,
			},
			*/
		}
	},
	watch: {

	}, 
	computed: {
		totalOutstanding() {
			return this.reportdata.data.reduce((sum, item) => sum + item.Count, 0);
		},
	},

    mounted() {
		//this.getTopBottomSales();
    },
    methods:{
		async getTopBottomSales() {
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams += '/v1/bright/brightperformancetopbottomsales?'

			/*
            this.urlRequestParams += '&plant='+this.plant
			this.urlRequestParams += '&station='+this.stationid
			this.urlRequestParams += '&type='+this.stationtype
			this.urlRequestParams += '&area='+this.area
			this.urlRequestParams += '&owner='+this.owner
			this.urlRequestParams += '&lokasi='+this.lokasi
			this.urlRequestParams += '&category='+this.category
			this.urlRequestParams += '&subcategory='+this.subcategory
			this.urlRequestParams += '&status='+this.status
			*/

            this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.loading.isSuccess = true;
					this.reportdata = response.data;
					
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})
        },
	}
}
</script>


<style>
.list-item-container {
    width: 100%;
    margin: 0 auto;
}

.list-item2 {
	display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}

.list-item-label {
	width: 60%;
	text-align: left;
	font-weight: normal;
}

.table-outstanding-status-by-area tr td {
	padding: 10px 40x;
}
  </style>